import { useSubscription } from "@apollo/react-hooks";
import { Card, Empty } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Empty_EscalationVector from "../../../Assets/Images/Empty/Empty_EscalationVector.svg";
import { Loader } from "../../../Components/Loader";
import { CustIcon } from "../../../Components/Svgs/Svgs";
import { GET_USER_ESCALATION_DETAILS } from "../../../Graphql/subscriptions";
import "./Escalations.less";

export const Escalations = ({ userTimeZone }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [formattedescalatedData, setFormattedescalatedData] = useState([]);

  const { data: userEscalationData, loading: isUserEscalationDataLoading } =
    useSubscription(GET_USER_ESCALATION_DETAILS, {
      variables: {
        user_id: localStorage.getItem("user_id"),
        todaysDate: moment.tz(moment(), userTimeZone).format("YYYY-MM-DD"),
      },
      shouldResubscribe: true,
      skip: !userTimeZone,
      fetchPolicy: "cache-and-network",
    });

  useEffect(() => {
    if (userEscalationData) {
      formatEscalationData();
    }
  }, [userEscalationData]);

  const formatEscalationData = () => {
    let escalationData = [];
    userEscalationData.user_reporting_view.forEach(
      ({ subordinate_details }) => {
        let singleData = subordinate_details.user_tasks_maps.flatMap(
          ({ task, updated_at, user }) => [
            {
              task_description: task.description,
              escalation_date_time: updated_at,
              escalted_at: moment(updated_at).fromNow(),
              user_name: user.full_name,
              location_name:
                user.user_location_maps.length !== 1
                  ? user.user_location_maps.length + "locations"
                  : user.user_location_maps[0].locationDetails.location_name,
            },
          ]
        );
        escalationData.push(...singleData);
      }
    );
    escalationData.sort((a, b) => {
      if (
        moment(a.escalation_date_time).isBefore(moment(b.escalation_date_time))
      ) {
        return 1;
      } else {
        return -1;
      }
    });
    setFormattedescalatedData(escalationData);
    setIsLoading(false);
  };

  return (
    <section className="escalationsSec">
      <div className="secSubTitle">
        <div className="stLeft">
          <h5>Escalations</h5>
        </div>
      </div>

      <div className="escalations_blk">
        <Card className="escalationsCard">
          {isUserEscalationDataLoading || isLoading ? (
            <Loader />
          ) : formattedescalatedData.length === 0 ? (
            <Empty
              image={Empty_EscalationVector}
              description="Yay! You can check all the escalated tasks of your employees, here. Keep an eye on this!"
            />
          ) : (
            <ul className="list-inline escalationsList">
              {formattedescalatedData.map((task, index) => (
                <li key={index} className="d-flex flex-column myEscalations">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="name">
                      <strong>{task.user_name}</strong>
                    </div>
                  </div>
                  <div className="myEscalationsDetails">
                    <div className="d-flex loactionTime py-1">
                      <div className="d-inline-flex">
                        <CustIcon type="location" className="mr-1" />
                        <span>{task.location_name}</span>
                      </div>
                      <span className="px-2 text-dark">|</span>{" "}
                      <div className="time">{task.escalted_at}</div>
                    </div>
                    <p className="mb-0">{task.task_description}</p>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </Card>
      </div>
    </section>
  );
};
